import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { Home, Introducao, Identidade, ExpressaoVerbal, ExpressaoVisual, Downloads } from '../pages';
import { Header } from '.';

export default (props) => (
  <Fragment>
    <Header />
    <Route path="/inicio" component={Home} />
    <Route path="/introducao" component={Introducao} />
    <Route path="/identidade" component={Identidade} />
    <Route path="/expressaoverbal" component={ExpressaoVerbal} />
    <Route path="/expressaovisual" component={ExpressaoVisual} />
    <Route path="/downloads" component={Downloads} />
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/AuthenticatedArea.js